import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SecondaryButton from '../../SecondaryButton';
import CheckBox from '../../CheckBox';
import { ButtonPanelWrapper } from '../styles';

const QuizContentEditorFooter = ({ type, data, payload, setPayload, loading = false, updating = false }) => {
  const [redoable, setRedoable] = useState(data.redoable);

  const isUpdating = loading || updating;

  useEffect(() => {
    if (!isUpdating && data.redoable !== redoable) {
      setPayload({ ...payload, redoable, immediateSave: true });
    }
  }, [redoable]);

  const addQuestion = () =>
    !isUpdating &&
    document.dispatchEvent(new CustomEvent('question.added', { detail: { questions: payload?.questions || [] } }));

  return (
    <ButtonPanelWrapper>
      {type === 'quiz' && (
        <CheckBox
          id="redoQuiz"
          text={i18n.__('quiz_redoable')}
          defaultChecked={redoable}
          onChange={() => setRedoable(!redoable)}
          value={1}
          lightMode={true}
          disabled={loading}
        />
      )}
      <SecondaryButton
        onClick={addQuestion}
        disabled={isUpdating}
        text={i18n.__('activity_add_question')}
        className="add-question-button"
      />
    </ButtonPanelWrapper>
  );
};

export default QuizContentEditorFooter;

QuizContentEditorFooter.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  payload: PropTypes.object.isRequired,
  setPayload: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  updating: PropTypes.bool,
};
